import React from "react";
import { Link, useLocation } from "react-router-dom";
import { consultantmage, logo, pharmacy, userpatient } from "../Constant/Index";
import { useSelector } from "react-redux";

const Header = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const token = useSelector((state) => state?.Auth?.token);
  const userprofie = useSelector((state) => state?.Auth?.userprofie);
  const userDetail = useSelector((state) => state?.Auth?.users);
  const myrole = useSelector((state) => state?.Auth?.role);

  const personalInfoPages = [
    "/personal-info",
    "/change-password",
    "/medical-report",
    "/my-order",
    "/my-order-detail",
    "/my-consultations",
    "/user-shift-edit",
    "/consultation-detail",
    "/past-consultations",
    "/current-consultations",
    "/current-consultations-detail",
    "/past-consultations-detail",
    "/user-chat",
    "/user-prescription",
    "/user-prescription-placeorder",
    "/user-notes",
    "/user-billing-detail",
    "/user-prescription-address",
    "/user-thankyou",
    "/user-videocall",
    "/user-write-now",
  ];

  const physicianInfoPages = [
    "/physician-personal-info",
    "/physician-password",
    "/physician-myconsultations",
    "/physician-consultation-detail",
    "/physician-current-consultations",
    "/physician-current-detail",
    "/physician-past-consultations",
    "/physician-past-detail",
    "/physician-current-chat",
    "/physician-past-chat",
    "/physician-video-call",
    "/physician-prescription",
    "/write-prescription",
    "/physician-notes",
    "/physician-write-notes",
  ];

  const pharmacyInfoPages = [
    "/pharmacy-info",
    "/pharmacy-change-password",
    "/prescription-orders-all",
    "/prescription-orders-pending",
    "/prescription-orders-inprogress",
    "/prescription-orders-complete",
    "/prescription-orders-details",
  ];

  const isPersonalInfoPage = personalInfoPages.includes(currentPath);
  const isPhysicianPersonalInfoPage = physicianInfoPages.includes(currentPath);
  const isPharmacyInfoPage = pharmacyInfoPages.includes(currentPath);

  return (
    <header className="site-header">
      <div className="container">
        <div className="header-wrapper py-3">
          <div className="header-start d-flex gap-sm-0 justify-content-between align-items-center">
            <div className="logo-wrapper d-flex align-items-center justify-content-between">
              <div className="header-logo">
                <figure className="header-logo">
                  <Link to="/">
                    <img src={logo} className="logo-here light-image" alt="" />
                  </Link>
                </figure>
              </div>
            </div>
            <div className="d-lg-flex align-items-center gap-3 d-none">
              <ul className="header-link list-unstyled d-md-flex flex-lg-row align-items-center gap-5 mb-0 z-index-1 d-none">
                <li className="single-item">
                  <Link
                    to="/"
                    className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
                  >
                    Home
                  </Link>
                </li>
                <li className="single-item">
                  <Link
                    to="/about-us"
                    className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
                  >
                    About Us
                  </Link>
                </li>
                <li className="single-item">
                  <Link
                    to="/how-it-work"
                    className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
                  >
                    How it works
                  </Link>
                </li>
                <li className="single-item">
                  <Link
                    to="/contact-us"
                    className="header-link level-7 link-here primary-regular-font text-decoration-none extra-color-1"
                  >
                    Contact us
                  </Link>
                </li>
                <ul className="navigation-list">
                  {!(
                    (token && myrole == "patient") ||
                    (token && myrole == "physician") ||
                    (token && myrole == "pharmacy")
                  ) && (
                    <li className="single-item">
                      <Link
                        to="/sign-up"
                        className="start-now btn wrapper-btn-main log-in level-7 primary-regular-font text-decoration-none"
                      >
                        <span className="bg-wrapper">GET STARTED</span>
                      </Link>
                    </li>
                  )}
                  {token && myrole == "patient" && (
                    <li className="single-item">
                      <Link
                        style={{
                          textDecoration: "none",
                          color: "#000",
                        }}
                        to="/personal-info"
                      >
                        <div className="user-profile d-flex align-items-center gap-3">
                          <div className="edit-btn-profile">
                            {!userprofie ? (
                              <img
                                src={userDetail?.profile_image_url}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            ) : (
                              <img
                                src={userprofie}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            )}
                          </div>
                          <h4 className="secondary-bold-font level-7 mb-0">
                            {userDetail?.first_name}
                          </h4>
                        </div>
                      </Link>
                    </li>
                  )}
                  {token && myrole == "physician" && (
                    <li className="single-item">
                      <Link
                        style={{
                          textDecoration: "none",
                          color: "#000",
                        }}
                        to="/physician-personal-info"
                      >
                        <div className="physician-profile d-flex align-items-center gap-3">
                          <div className="edit-btn-profile">
                            {!userprofie ? (
                              <img
                                src={userDetail?.profile_image_url}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            ) : (
                              <img
                                src={userprofie}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            )}
                          </div>
                          <h4 className="secondary-bold-font level-7 mb-0">
                            {userDetail?.first_name}
                          </h4>
                        </div>
                      </Link>
                    </li>
                  )}
                  {token && myrole == "pharmacy" && (
                    <li className="single-item">
                      <Link to="/pharmacy-perosnal-info">
                        <div className="pharmacy-profile d-flex align-items-center gap-3">
                          <div className="edit-btn-profile">
                            {!userprofie ? (
                              <img
                                src={userDetail?.profile_image_url}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            ) : (
                              <img
                                src={userprofie}
                                className="img-fluid nav-anchor-bg"
                                alt=""
                              />
                            )}
                          </div>
                          <h4 className="secondary-bold-font level-7 mb-0">
                            {userDetail?.first_name}
                          </h4>
                        </div>
                      </Link>
                    </li>
                  )}
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
